Vue.component("slidemap", {
  props: {
    dataset: {
      type: String
    },
    isLoading: {
      type: Boolean
    },
    selectedData: {
      type: Object
    },
    dataKey: {
      type: String
    },
    updates: {
      type: Number
    },
    type: {
      type: String
    },
    tableRows: {
      type: Object
    }
  },
  data() {
    return {
      svg: false,
      path: null,
      width: 750,
      height: 500,
      data: {},
      mapDrawn: false,
      tooltip: null,
      keyFilters: false,
      visualizationItems: {},
      key0: "none",
      key1: "none",
      quintNumber: 4,
      quintiles: false,
      quintfilter: false,
      mapid: "map_" + this.makeid(),
      numkeys: 1,
      abbrToState: this.getAbbrToState(),
      initialLoad: true
    };
  },
  computed: {
    key0Robust() {
      if (
        !this.visualizationItems ||
        !this.visualizationItems[0] ||
        !this.visualizationItems[0].data_type
      ) {
        return false;
      }
      let html = "";
      let vals;
      switch (this.visualizationItems[0].data_type) {
        case "category":
          vals = this.visualizationItems[0].values;
          let numcats = vals.length;
          let opac = ".1";
          html += '<div class="map_key_display_robust_wrapper">';
          for (let i = 0; i < numcats; i++) {
            opac = this.getColorOpacityForCategory(i, numcats);
            html +=
              '<div class="map_key_display_robust"><div class="map_key_display" style="background-color: rgba(0, 85, 162, ' +
              opac +
              ')"></div>' +
              vals[i] +
              "</div>";
          }
          html += "</div>";
          break;
        case "binary":
          vals = this.visualizationItems[0].values;
          html += '<div class="map_key_display_robust_wrapper">';
          html +=
            '<div class="map_key_robust"><div class="map_key_display" style="background-color: rgba(0, 85, 162, 0.1)"></div>' +
            vals["OFF"] +
            "</div>";
          html +=
            '<div class="map_key_robust"><div class="map_key_display" style="background-color: rgba(0, 85, 162, 0.8)"></div>' +
            vals["ON"] +
            "</div>";

          html += "</div>";
          break;
        case "scale":
        default:
          let labels = this.getQuintLabels();
          if (!labels) {
            break;
          }
          html += '<div class="map_key_display_robust_wrapper">';
          for (let i = 0; i < Object.keys(labels).length; i++) {
            let opac = 0.1;
            opac = this.getOpac(i + 1, Object.keys(labels).length);
            html += '<div class="map_key_display_robust">';
            html +=
              '<div class="map_key_display" style="background-color: rgba(0, 85, 162, ' +
              opac +
              ')"></div>';
            html += labels[i];
            html += "</div>";
          }
          html += "</div>";
          break;
      }

      return html;
    },
    key1Robust() {
      if (
        !this.visualizationItems ||
        !this.visualizationItems[1] ||
        !this.visualizationItems[1].data_type ||
        this.visualizationItems[1].type == "scale"
      ) {
        return false;
      }
      let html = "";
      let vals = this.visualizationItems[1].values;
      switch (this.visualizationItems[1].data_type) {
        case "category":
          html += '<div class="map_key_display_robust_wrapper">';
          html +=
            '<div class="map_key_robust"><div class="map_key_display"></div>' + vals[0] + "</div>";

          html +=
            '<div class="map_key_robust"><div class="map_key_display"><svg width="20" height="20"><path d="M 0 10 L 10 0" class="maphash" /><path d="M 0 20 L 20 0" class="maphash" /><path d="M 0 30 L 30 0" class="maphash" /></svg></div>' +
            vals[1] +
            "</div>";

          html +=
            '<div class="map_key_robust"><div class="map_key_display"><svg width="20" height="20"><path d="M 10 0 L 20 10" class="maphash" /><path d="M 0 0 L 20 20" class="maphash" /><path d="M 0 10 L 10 20" class="maphash" /><path d="M 0 10 L 10 0" class="maphash" /><path d="M 0 20 L 20 0" class="maphash" /><path d="M 0 30 L 30 0" class="maphash" /></svg></div>' +
            vals[2] +
            "</div>";

          html += "</div>";
          break;
        case "binary":
          html += '<div class="map_key_display_robust_wrapper">';
          html +=
            '<div class="map_key_robust"><div class="map_key_display"></div>' +
            vals["OFF"] +
            "</div>";
          html +=
            '<div class="map_key_robust"><div class="map_key_display"><svg width="20" height="20"><path d="M 10 0 L 20 10" class="maphash" /><path d="M 0 0 L 20 20" class="maphash" /><path d="M 0 10 L 10 20" class="maphash" /><path d="M 0 10 L 10 0" class="maphash" /><path d="M 0 20 L 20 0" class="maphash" /><path d="M 0 30 L 30 0" class="maphash" /></svg></div>' +
            vals["ON"] +
            "</div>";
          html += "</div>";
          break;
      }
      return html;
    },
    keyFiltersHash() {
      let obj = {};
      for (let i = 0; i < Object.keys(this.keyFilters).length; i++) {
        let t = this.keyFilters[i];
        // scalar doesn't work for the hash
        if (t.data_type == "scale") {
          continue;
        }
        obj[i] = this.keyFilters[i];
      }
      return obj;
    },
    showKey() {
      if (this.type == "results") {
        return true;
      }
      return false;
    }
  },
  watch: {
    updates: function () {
      this.updateKey();
      if (this.type != "picker" && this.dataset == "") {
        this.setDynamicData();
      }
      this.drawMap();
      this.initialLoad = false;
    },
    /*
        key0: function () {

            if (this.mounted) {
                this.updateKeySelect(0);
            }
            
        },
        /**/
    //keyFilters: {
    keyFilters: {
      deep: true,
      handler(oldVal, newVal) {
        if (!this.initialLoad && oldVal[this.key0] != newVal[this.key0]) {
          this.updateKeySelect(0);
        }
      }
    }
  },
  mounted() {
    let $this = this;
    d3.select(window).on("resize", this.scaleMap);
    $this.setProjection();
    $this.setDefaultKeys();
    $this.initialDraw();
  },
  methods: {
    makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return text;
    },
    getProp(item) {
      return item;
    },
    setProjection() {
      let $this = this;

      // setting projection
      var projection = d3
        .geoAlbersUsa()
        .translate([$this.width / 2, $this.height / 2]) // translate to center of screen
        .scale([1000]);
      // Define path generator
      let path = d3
        .geoPath() // path generator that will convert GeoJSON to SVG paths
        .projection(projection); // tell path generator to use albersUsa projection
      this.path = path;
    },
    initialDraw() {
      let $this = this;
      if ($this.type == "picker") {
        let ds = "/wp-content/themes/slide/assets/data/states-empty.json";
        let fullname;
        d3.json(ds).then(function (json) {
          for (i = 0; i < json.length; i++) {
            $this.data[json[i].STATE] = json[i];
          }
          $this.drawMap();
        });
        return;
      }

      // DATASET = '' FOR NON STATE-SURVEY
      if ($this.dataset == "") {
        $this.setDynamicData();

        return;
      } else {
        d3.json($this.dataset).then(function (json) {
          for (i = 0; i < json.length; i++) {
            $this.data[json[i].STATE] = json[i];
          }
          $this.drawMap();
        });
      }
    },
    setDynamicData() {
      let $this = this;
      let ds = "/wp-content/themes/slide/assets/data/states-empty.json";
      d3.json(ds).then(function (json) {
        for (i = 0; i < json.length; i++) {
          $this.data[json[i].STATE] = json[i];
          fullname = $this.abbrToState[json[i].STATE].toUpperCase();
          if ($this.tableRows[fullname] !== undefined) {
            for (const property in $this.tableRows[fullname]) {
              $this.data[json[i].STATE][property] = $this.tableRows[fullname][property];
            }
          }
        }
        $this.drawMap();
      });
    },
    scaleMap() {
      let mapDOM = document.getElementById(this.mapid);
      if (mapDOM === null) {
        return;
      }
      let m = mapDOM.offsetWidth;

      // SET DEFAULT IF THE MAP CURRENTLY HAS NO WIDTH
      if (m == 0) {
        m = 750;
      }
      //let h = m*0.53;
      let h = m * 0.7;
      d3.select("#" + this.mapid + " g").attr("transform", "scale(" + m / 900 + ")");
      //d3.select("#" + this.mapid + " svg").attr("height", h);
      d3.select("#" + this.mapid + " svg").attr("height", h);
      mapDOM.style.height = h + "px";
    },
    drawMap() {
      let $this = this;
      this.keyFilters = { ...this.selectedData.selected.filters[this.dataKey] };

      $this.removeExtraLayers();
      $this.appendTooltip();

      if (!this.mapDrawn) {
        $this.svg = d3
          .select("#" + $this.mapid + " svg")
          //.append("svg")
          .attr("width", "100%")
          .append("g");
        //$this.svg.append("g")
        d3.json("/wp-content/themes/slide/assets/data/us-states.json").then(function (json) {
          $this.svg
            .selectAll("path")
            .data(json.features)
            .enter()
            .append("path")
            .attr("d", $this.path)
            .attr("id", function (d) {
              return "state-" + d.properties.abbr;
            })
            .style("stroke-width", "1")
            .style("stroke", "#fff")
            .each((d) => {
              $this.setStateStyles(d.properties.abbr);
            })
            .on("mouseover", function (event, d) {
              $this.mouseover(event, d);
            })
            .on("mouseout", function (event, d) {
              $this.tooltip.transition().duration(500).style("opacity", 0);
            })
            .on("click", function (event, d) {
              $this.click(event, d);
            });
        });

        /*
                    var zoom = d3.zoom()
                        .scaleExtent([1, 8])
                        .on('zoom', function() {
                            g.selectAll('path')
                            .attr('transform', d3.event.transform);
                    });

                    this.svg.call(zoom);
                    */
      } else {
        this.svg
          .transition()
          .selectAll("path")
          .each((d) => {
            if (d) {
              $this.setStateStyles(d.properties.abbr);
            }
          });
      }
      this.scaleMap();
      this.mapDrawn = true;
    },
    removeExtraLayers() {
      document.querySelectorAll(".state-overlay").forEach((e) => e.remove());
    },
    appendTooltip() {
      document.querySelectorAll(".map_tooltip").forEach((e) => e.remove());
      this.tooltip = d3
        .select("body")
        .append("div")
        .attr("class", "map_tooltip")
        .style("opacity", 0);
    },
    mouseover(event, d) {
      // NO MOUSEOVER EVENT FOR PICKER
      if (this.type == "picker") {
        return;
      }

      let $this = this;
      let pageX = event.pageX;
      let pageY = event.pageY;
      let html = "";

      html += "<h3>" + d.properties.STATE + "</h3>";
      let filters = $this.selectedData.selected.filters[$this.dataKey];
      let t = "text";

      for (let i = 0; i < filters.length; i++) {
        let filter = filters[i];
        let t = "text";
        if (filter.data_format) {
          t = filter.data_format;
        }

        html += "<div>";
        html += $this.getDataName(filter) + ": ";
        if ($this.data[d.properties.abbr][filter[$this.dataKey]] == undefined) {
          html += "No Data";
        } else {
          html += formatSlideData($this.data[d.properties.abbr][filter[$this.dataKey]], t);
        }

        html += "</div>";
      }

      $this.tooltip.transition().duration(200).style("opacity", 1);
      $this.tooltip
        .html(html)
        .style("left", pageX + "px")
        .style("top", pageY - 28 + "px");
    },
    click(event, d) {
      // IGNORE CLICKS FOR MOST TYPES OF MAP
      if (this.type != "picker") {
        return;
      }

      // NOTE: PICKER ASSUMES THAT THIS IS A CHILD OF AN AUTOCOMPLETE
      // WILL NEED TO INCLUDE AN ISCHILD CHECK OR SIMILAR IF WE ALSO WANT STAND-ALONE PICKER
      let st = d.properties.abbr;
      let states = this.selectedData.selected.filters.STATE;
      let add = true;

      if (states) {
        for (i = 0; i < Object.keys(states).length; i++) {
          if (states[i].abbr == st) {
            //delete this.selectedData.selected.filters.STATE[i]
            add = false;
          }
        }
      }
      this.$emit("updatesearch", d.properties, add);
      //this.$emit('updatesearch', st, add);
      this.drawMap();
    },
    setStateStyles(st) {
      let $this = this;

      //let filters = $this.selectedData.selected.filters[$this.dataKey];
      let filters = $this.visualizationItems;
      //let filters = $this.keyFilters;

      // ADD COLOR PATTER FOR FIRST FILTER
      this.addColorPattern(st, filters[0]);

      // ADD PATTERN FOR SECOND FILTER
      if (this.numkeys > 1 && filters[1] && filters[1].type != "scale") {
        this.addHashPattern(st, filters[1]);
      }
    },
    addColorPattern(st, filter) {
      let $this = this;
      let opac = ".1";
      let active = $this.svg.select("path#state-" + st);

      // SET STATEPICKER
      if (this.type == "picker") {
        let states = $this.selectedData.selected.filters.STATE;
        if (states) {
          for (i = 0; i < Object.keys(states).length; i++) {
            if (states[i].abbr == st) {
              opac = ".8";
            }
          }
        }
        active.style("fill", "rgba(0, 85, 162, " + opac + ")");
        return;
      }
      // IF THE FILTER IS NONE, EVERYTHING IS TURNED OFF
      if (filter === undefined) {
        active.style("fill", "rgba(0, 85, 162, " + opac + ")");
        return;
      }
      let t = filter.data_type;
      let k = filter[$this.dataKey];
      let thisdata = $this.data[st];
      let r = thisdata[k];
      let v;
      switch (t) {
        case "binary":
          v = filter.values["ON"];
          if (r == v) {
            opac = ".8";
          }
          break;
        case "category":
          let numcats = filter.values.length;
          v = Object.keys(filter.values).find((key) => filter.values[key] === r);
          opac = this.getColorOpacityForCategory(v, numcats);
          break;
        case "scale":
        default:
          opac = this.getColorOpacityForScale(r, filter);
      }
      if (opac == 0) {
        active.style("fill", "rgba(24, 24, 24, .7)");
      } else {
        active.style("fill", "rgba(0, 85, 162, " + opac + ")");
      }
    },
    getColorOpacityForCategory(v, numcats) {
      let opac = ".1";
      switch (v) {
        case undefined:
          opac = 0;
          break;
        case 0:
        case "0":
          break;
        case 1:
        case "1":
          switch (numcats) {
            case 2:
              opac = ".8";
              break;
            case 3:
              opac = ".533";
              break;
            case 4:
              opac = ".25";
              break;
          }
          break;
        case 2:
        case "2":
          switch (numcats) {
            case 3:
              opac = ".8";
              break;
            case 4:
              opac = ".5";
              break;
          }
          break;
      }
      return opac;
    },
    getColorOpacityForScale(v, filter) {
      let opac = 0.1;

      let quintiles = this.getQuintiles(filter);
      let num = Object.keys(quintiles).length;
      for (let i = num; i > 0; i--) {
        if (v >= quintiles[i]) {
          opac = this.getOpac(i + 1, num);
          break;
        }
      }
      if (v == undefined) {
        opac = 0;
      }
      return opac;
    },
    getOpac(num, denom) {
      return (num / denom) * 0.8;
    },
    getQuintiles(filter) {
      let k = filter[this.dataKey];
      let num = this.quintNumber;
      let arr = [];
      for (const st in this.data) {
        if (this.data[st][k]) {
          arr.push(this.data[st][k] * 1);
        }
      }
      arr.sort(function (a, b) {
        return a - b;
      });
      let q = {};
      q[0] = 0;
      for (let i = 1; i < num; i++) {
        //q[i] = (100 / (num - i)) / 100; not correct
        let fraction = 100 / num;
        let thisF = (fraction * i) / 100;
        q[i] = thisF;
      }
      let quintiles = {};
      for (k in q) {
        let i = q[k] * arr.length;
        if (Math.floor(i) == i) {
          result = (arr[i - 1] + arr[i]) / 2;
        } else {
          result = arr[Math.floor(i)];
        }
        quintiles[k] = result;
      }
      this.quintiles = quintiles;
      this.quintfilter = filter;
      return quintiles;
    },
    getQuintLabels() {
      if (!this.quintiles) {
        return false;
      }
      let labels = {};
      let num = Object.keys(this.quintiles).length;
      let f = this.quintfilter;
      let t = "text";
      if (f.data_format) {
        t = f.data_format;
      }

      for (let i = 0; i < num; i++) {
        if (i == 0) {
          labels[i] = "0";
          if (f.wholenumbers || t == "Number") {
            if (this.quintiles[1] == 1) {
              continue;
            }
            labels[i] += "-" + formatSlideData(this.quintiles[1] - 1, t);
            continue;
          }
          labels[i] += "-" + formatSlideData(this.quintiles[1] - 0.01, t);
          continue;
        }
        if (i == 1) {
          labels[i] = "";
          if (f.wholenumbers || t == "Number") {
            if (this.quintiles[1] == this.quintiles[2] - 1) {
              labels[i] = formatSlideData(this.quintiles[1], t);
            } else {
              labels[i] =
                formatSlideData(this.quintiles[1], t) +
                "-" +
                formatSlideData(this.quintiles[2] - 1, t);
            }
            continue;
          }
          labels[i] =
            formatSlideData(this.quintiles[1], t) +
            "-" +
            formatSlideData(this.quintiles[2] - 0.01, t);
          continue;
        }
        if (i == num - 1) {
          labels[i] = formatSlideData(this.quintiles[i], t) + "+";
          continue;
        }
        let n = i + 1;
        if (f.wholenumbers || t == "Number") {
          if (this.quintiles[i] == this.quintiles[n] - 1) {
            labels[i] = formatSlideData(this.quintiles[i], t);
          } else {
            if (f.wholenumbers) {
              labels[i] =
                formatSlideData(this.quintiles[i], t) +
                "-" +
                formatSlideData(this.quintiles[n] - 1, t);
              continue;
            }
            labels[i] =
              formatSlideData(this.quintiles[i], t) +
              "-" +
              formatSlideData(this.quintiles[n] - 1, t);
          }
          continue;
        }
        labels[i] =
          formatSlideData(this.quintiles[i], t) +
          "-" +
          formatSlideData(this.quintiles[n] - 0.01, t);
      }
      return labels;
    },
    addHashPattern(st, filter) {
      // IF THE FILTER IS NONE, EVERYTHING IS TURNED OFF
      if (filter === undefined) {
        return;
      }
      let $this = this;
      let active = $this.svg.select("path#state-" + st);
      let k = filter.key;
      let v = filter.values["ON"];
      let thisdata = $this.data[st];
      let r = thisdata[k];
      let t = filter.data_type;
      let thisd = active.attr("d");
      let add = false;
      let pattern = 4;

      switch (t) {
        case "binary":
          if (r == v) {
            add = true;
          }
          break;
        case "category":
          v = Object.keys(filter.values).find((key) => filter.values[key] === r);
          switch (v) {
            case "0":
              break;
            case "1":
              add = true;
              pattern = 3;
              break;
            case "2":
              add = true;
              break;
          }
      }
      if (add) {
        let url = "url(#pattern-" + pattern + ")";
        $this.svg
          .append("path")
          .attr("d", thisd)
          .style("fill", url)
          .style("pointer-events", "none")
          .attr("id", "state1-" + st)
          .attr("class", "state-overlay");
      }
    },
    async updateKey() {
      this.keyFilters = { ...this.selectedData.selected.filters[this.dataKey] };
    },
    async updateKeySelect(selector) {
      await this.updateVisualizationFilterFromKey(selector);
      await this.updateKey();
      this.drawMap();
    },
    updateVisualizationFilterFromKey(selector) {
      let select = document.getElementById("map_key_select_" + selector);
      let val = select.value;
      if (val == "none") {
        delete this.visualizationItems[selector];
      } else {
        this.visualizationItems[selector] = this.keyFilters[val];
      }
    },
    setDefaultKeys() {
      let $this = this;
      if (!this.showKey) {
        return;
      }

      let l = this.selectedData.selected.filters[this.dataKey].length;
      let vizIndex = 0;
      let defaultViz = {};
      let vizKeys = [];
      for (let i = 0; i < l; i++) {
        if (this.selectedData.selected.filters[this.dataKey][i].defaultViz) {
          defaultViz[vizIndex] = this.selectedData.selected.filters[this.dataKey][i];
          vizKeys.push(this.selectedData.selected.filters[this.dataKey][i][this.dataKey]);
          vizIndex++;
        }
      }
      this.visualizationItems = defaultViz;

      for (let i = 0; i < l; i++) {
        if (vizIndex > 1) {
          break;
        }
        if (!vizKeys.includes(this.selectedData.selected.filters[this.dataKey][i][this.dataKey])) {
          defaultViz[vizIndex] = this.selectedData.selected.filters[this.dataKey][i];
          vizIndex++;
        }
      }
      Object.keys(defaultViz).forEach((v) => {
        let sel = document.getElementById("map_key_select_" + v);
        let lab = defaultViz[v].data_name;
        // need to get key from label, to set
        for (let j = 0; j < l; j++) {
          if (this.selectedData.selected.filters[this.dataKey][j].data_name == lab) {
            if (v == 0) {
              $this.key0 = j;
            }
            if (v == 1) {
              $this.key1 = j.toString();
            }
          }
        }
      });
      this.visualizationItems = defaultViz;
    },
    getDataName(item) {
      if (item.data_name_short) {
        return item.data_name_short;
      }
      return item.data_name;
    },
    getAbbrToState() {
      return {
        AL: "Alabama",
        AK: "Alaska",
        AS: "American Samoa",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        DC: "District Of Columbia",
        FM: "Federated States Of Micronesia",
        FL: "Florida",
        GA: "Georgia",
        GU: "Guam",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MH: "Marshall Islands",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        MP: "Northern Mariana Islands",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PW: "Palau",
        PA: "Pennsylvania",
        PR: "Puerto Rico",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VI: "Virgin Islands",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming"
      };
    }
  }
});
